module.exports = __webpack_public_path__ + "img/XY.2a1e74e9.png";